module.exports = __webpack_public_path__ + "img/logomark-cerulean.b7158d1d.svg";